export const REACT_APP_URL_HOST = process.env.REACT_APP_URL_HOST || 'http://localhost:8080';
export const REACT_APP_API_BASE = process.env.REACT_APP_API_BASE || 'https://delfiwebapiqa.azurewebsites.net';
export const REACT_APP_GEOJSON_LOCATION = process.env.REACT_APP_GEOJSON_LOCATION || 'https://delfinextqa.azureedge.net/delfinext-geo'; //'https://delfinext.azureedge.net/delfinext-geo';//'/geo';
export const REACT_APP_INSIGHTS_INSTRUMENTATION_KEY = process.env.REACT_APP_INSIGHTS_INSTRUMENTATION_KEY || '8334368d-1b62-47e1-8b8d-b324771d9ccd';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyC2IZV74qnLYvnrqDvjhhle_047NMWk9mg';
export const API_VER = 'v2';
export const API_KEY = 'b09e70a7-c026-4ec6-8796-83b2ecc4a44f'
export const API_URL = (path, params) => {
    if (params) {
        return `${REACT_APP_API_BASE}${path}?${params}&json=true&apiKey=${API_KEY}`;
    }
    
    return `${REACT_APP_API_BASE}${path}?json=true&apiKey=${API_KEY}`;
}
export const TURNOVER_CLASSES = [{
    label: 1,
    min: 1,
    max: 499
}, {
    label: 2,
    min: 500,
    max: 999
}, {
    label: 3,
    min: 1000,
    max: 1999
}, {
    label: 4,
    min: 2000,
    max: 2999
}, {
    label: 5,
    min: 3000,
    max: 3999
}, {
    label: 6,
    min: 4000,
    max: 4999
}, {
    label: 7,
    min: 5000,
    max: 5999
}, {
    label: 8,
    min: 6000,
    max: 7999
}, {
    label: 9,
    min: 8000,
    max: 9999
}, {
    label: 10,
    min: 10000,
    max: 14999
}, {
    label: 11,
    min: 15000,
    max: 19999
}, {
    label: 12,
    min: 20000,
    max: 24999
}, {
    label: 13,
    min: 25000,
    max: 29999
}, {
    label: 14,
    min: 30000,
    max: 39999
}, {
    label: 15,
    min: 40000,
    max: 49999
}, {
    label: 16,
    min: 50000,
    max: 59999
}, {
    label: 17,
    min: 60000,
    max: 74999
}, {
    label: 18,
    min: 75000,
    max: 99999
}, {
    label: 19,
    min: 100000,
    max: 1500000
}];

export const SALES_SPACE_GROUP = [{
    label: 1,
    min: 0,
    max: 99
}, {
    label: 2,
    min: 100,
    max: 399
}, {
    label: 3,
    min: 400,
    max: 999
}, {
    label: 4,
    min: 1000,
    max: 2499
}, {
    label: 5,
    min: 2500,
    max: 7499
}, {
    label: 6,
    min: 7500,
    max: 10000000
}];

export const getSalesSpaceGroupFromRetailArea = (value) => {
    return SALES_SPACE_GROUP.find(group => {
        return  value >= group.min && value <= group.max;
    });
};

export const getSalesSpaceGroupFromIndex = (values) => {
    return {
        minGroup: SALES_SPACE_GROUP[values[0]],
        maxGroup: SALES_SPACE_GROUP[values[1]-1]
    }
};

export const getSalesSpaceGroupIndexFromLabel = (values) => {
    return [
        SALES_SPACE_GROUP.findIndex(group => group.label === values[0]),
        SALES_SPACE_GROUP.findIndex(group => group.label === values[1]) + 1
    ];
};

export const getTurnoverFromIndex = (values) => {
    return {
        minGroup: TURNOVER_CLASSES[values[0]],
        maxGroup: TURNOVER_CLASSES[values[1]-1]
    }
};

export const getTurnoverIndexFromLabel = (values) => {
    return [
        TURNOVER_CLASSES.findIndex(group => group.label === values[0]),
        TURNOVER_CLASSES.findIndex(group => group.label === values[1]) + 1
    ];
};

export const getPurchasingPowerTitle = (title) => {
    switch (title) {
        case 'Kvartil 1':
            return 'Låg';
        case 'Kvartil 2':
            return 'Medellåg';
        case 'Kvartil 3':
            return 'Medelhög';
        case 'Kvartil 4':
            return 'Hög';
        default:
            return '';
    }
};

export const getOriginTitle = (title) => {
    switch(title) {
        case 'Född i Sverige med båda föräldrar födda i Sverige':
            return 'Född i Sverige\n med båda föräldrar\n födda i Sverige';
        case 'Född i Sverige med en förälder född i Sverige':
            return 'Född i Sverige\n med en förälder\n född i Sverige';
        case 'Utländsk bakgrund, Född utomlands':
            return 'Utländsk bakgrund,\n Född utomlands';
        case 'Född i Sverige med båda föräldrarna födda utomlands':
            return 'Född i Sverige\n med båda föräldrarna\n födda utomlands';
        default:
            return title;
    }
};

export const getHouseholdTitle = (title) => {
    switch(title) {
        case 'Sammanboende med barn':
            return 'Sammanboende\n med barn';
        case 'Sammanboende utan barn':
            return 'Sammanboende\n utan barn';
        case 'Ensamstående med barn':
            return 'Ensamstående\n med barn';
        case 'Ensamstående utan barn':
            return 'Ensamstående\n utan barn';
        case 'Övriga hushåll':
            return 'Övriga\n hushåll';
        default:
            return title;
    }
    
};
